import { RootState } from '../../../rootReducer';
import { TestConnectorState } from './types';

export const selectTestConnectorState = (state: RootState): TestConnectorState =>
  state.connectors.test;
